var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-error":_vm.$props.errors.length > 0}},[_vm._t("default"),(_vm.errors)?_c('ul',_vm._l((_vm.errors),function(error){return _c('li',{key:error},[_vm._v(_vm._s(error))])}),0):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }